import axios from "axios";
import ApiConfig from "../../Utils/Configs/apiConfig";
import AlertMessage from "../../Components/AlertMessage/AlertMessage";

export interface ClientRegisterPayload {
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  adminId: string;
}

export const ClientRegisterApi = async (data: ClientRegisterPayload) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/BusinessClient/invite-client",
      data,
    );

    console.log("ClientRegisterApi Response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("ClientRegisterApi Error:", error);
    throw error.response?.data || error.message;
  }
};

export const verifyInviteApi = async (token: string) => {
  console.log("verifyInviteApi called with token:", token);
  try {
    const api = ApiConfig.getInstance();
    const response = await api.get(
      `/BusinessClient/verify-invite?token=${token}`,
    );
    console.log("the message is" + response.data.message);

    if (response.data.status.statusCode !== 200) {
      throw new Error(response.data.message || "Invalid token");
    }
    // console.log("verifyInviteApi Response:", response.data.status.statusCode);
    return response.data;
  } catch (error) {
    console.error("verifyInviteApi error:", error);
    throw error;
  }
};

export const setPasswordApi = async (token: string, password: string) => {
  try {
    const api = ApiConfig.getInstance();

    const response = await api.post("/Account/set-password", {
      token,
      password,
    });
    AlertMessage({ text: "Password set successfully!", type: "success" });
    return response.data;
  } catch (error: any) {
    AlertMessage({ text: error.message, type: "error" });
    throw error.response?.data || error.message;
  }
};
